


import FETCHING from "../library/fetching";
import UMUM from "../library/umum.js";



export default {
  components: {
  },
  data() {
    return {

      heatmap: {
      menus: [],
      data: []
        },
      loadingHeatmap: false,
      
      chartMenu: null,
      loadingChart: false,

      filterku: {
        instansi_id: '',
        unit_kerja_id: '',
        direktori_id: '',
        tahun: new Date().getFullYear(),

      },

      list_tahun: [
        { label: '2022', value: 2022 },
        { label: '2023', value: 2023 },
        { label: '2024', value: 2024 },
        { label: '2025', value: 2025 },
        { label: '2026', value: 2026 },
      ],
      dashboard_opd: {
        total_opd: 0,
        opd_sudah_upload: 0,
        opd_belum_upload: 0,
        doc_pending: 0,
        doc_approved: 0,
        doc_rejected: 0,
        doc_total: 0,
      },

      trista_monev: 0,
      list_data: [],
      listChart: null,
      list_opd_upload: [],

      UMUM: UMUM,
      FETCHING: FETCHING,
    }
  },

  computed: {
    isApprovalAdmin() {
      try {
        if (!localStorage.profile) return false;
        const profilex = JSON.parse(localStorage.profile);
        const profile = profilex.profile;
        const menuKlpId = parseInt(profile.aurel_new);
        return menuKlpId === 4 || menuKlpId === 16;
      } catch (e) {
        return false;
      }
    }
  },

  methods: {
    goToApproval(status) {
      this.$router.push({
        path: '/approvalDokumen',
        query: { status_approval: status, tahun: this.filterku.tahun }
      });
    },

    async loadHeatmap () {
      this.loadingHeatmap = true
      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD + 'heatmap-opd',
          {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              authorization: 'kikensbatara ' + localStorage.token
            },
            body: JSON.stringify({
              tahun: this.filterku.tahun
            })
          }
        )

        const data = await res.json()
        this.heatmap = data

      } catch (e) {
        console.error('Gagal load heatmap', e)
      } finally {
        this.loadingHeatmap = false
      }
    },


    onChangeTahun(val) {
      console.log('INPUT TAHUN:', val)
      this.filterku.tahun = val
      this.asyncFunc()
      this.loadChartMenu()
      this.loadHeatmap()
    },

    chart1: function (chartku, dn) {
      const chart = Highcharts.chart(chartku, {
        chart: {
          borderColor: '#efefef',
          borderWidth: 2,
        },
        title: {
          text: '-'
        },
        subtitle: {
          text: ' '
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        series: [{
          type: 'column',
          colorByPoint: true,
          data: [dn.jan, dn.feb, dn.mar, dn.apr, dn.mei, dn.jun, dn.jul, dn.agu, dn.sep, dn.okt, dn.nov, dn.des],
          showInLegend: false
        }]
      });


    },

    async asyncFunc () {
      console.log('REQUEST OPD DASHBOARD TAHUN:', this.filterku.tahun)
      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD + "opdDashboard",
          {
            method: 'POST',
            headers: {
              "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              tahun: this.filterku.tahun
            })
          }
        )

        const data = await res.json()

        this.dashboard_opd.total_opd = data.total_opd
        this.dashboard_opd.opd_sudah_upload = data.opd_sudah_upload
        this.dashboard_opd.opd_belum_upload = data.opd_belum_upload
        this.dashboard_opd.doc_pending = data.doc_pending
        this.dashboard_opd.doc_approved = data.doc_approved
        this.dashboard_opd.doc_rejected = data.doc_rejected
        this.dashboard_opd.doc_total = data.doc_total

      } catch (err) {
        console.error('Gagal load dashboard OPD', err)
      }
    },

    async loadChartMenu () {
      console.log('REQUEST CHART MENU TAHUN:', this.filterku.tahun)
      this.loadingChart = true

      try {
        const res = await fetch(
          this.$store.state.url.DASHBOARD + "menu-drilldown",
          {
            method: 'POST',
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              tahun: this.filterku.tahun
            })
          }
        )

        const data = await res.json()

        this.$nextTick(() => {
          this.renderChartMenu(data)
        })

      } catch (err) {
        console.error('Gagal load chart menu', err)
      } finally {
        this.loadingChart = false
      }
    },

  renderChartMenu (chartData) {
    if (this.chartMenu) {
      this.chartMenu.destroy()
    }

    this.chartMenu = Highcharts.chart('chartMenu', {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Upload Dokumen OPD per Menu'
      },
      subtitle: {
        text: `Tahun ${this.filterku.tahun}`
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        title: {
          text: 'Jumlah OPD'
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true
          }
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> OPD<br/>'
      },

      series: chartData.series,
      drilldown: chartData.drilldown
    })
  }




  },

  watch: {
      'filterku.tahun': {
        immediate: false,
        handler (val, oldVal) {
          console.log('WATCH TAHUN:', oldVal, '→', val)
          this.asyncFunc()
          this.loadChartMenu()
          this.loadHeatmap()
        }
      }
    },

  mounted() {
    var get_profile = JSON.parse(localStorage.profile);
    this.filterku.instansi_id = get_profile.profile.instansi_id;
    this.filterku.unit_kerja_id = get_profile.profile.unit_kerja;
    this.trista_monev = get_profile.profile.trista_monev;

    this.asyncFunc();
    this.loadChartMenu()
    this.loadHeatmap()

  },
}
